import { DITypes } from "@/core/@types/types";
import { inject, injectable } from "inversify";
import { EAcoesAntecipa, IAntecipaSlackHandler } from "./types";
import { type ISlackMessage } from "@/core/common/slackMessage/services/ports/SlackMessage";
import {
  type IMessageBuilderSlackStrategy,
  MessageBuilderSlackDi
} from "./strategies/IMessageBuilderStrategy";

@injectable()
export default class AntecipaSlackHandler implements IAntecipaSlackHandler {
  @inject(DITypes.SLACK_MENSAGEM) sendMessage!: ISlackMessage;
  @inject(MessageBuilderSlackDi) messageBuilder!: IMessageBuilderSlackStrategy;

  async enviar(location: EAcoesAntecipa): Promise<void> {
    const payload = {
      channel: "#alertas-antecipa",
      message: this.messageBuilder.buildMessage(location),
      displayInfo: true
    };

    return await this.sendMessage.enviarMensagem(payload);
  }
}
